import type { PublicUser, AuthTokens } from "@snowcord/shared";

interface AuthState {
  user: PublicUser | null;
  accessToken: string | null;
  privateKey: Uint8Array | null;
  isAuthenticated: boolean;

  login: (
    user: PublicUser,
    tokens: AuthTokens,
    privateKey: Uint8Array,
  ) => void;
  logout: () => void;
  setAccessToken: (token: string) => void;
}

export { create } from "zustand";

import { create } from "zustand";

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  privateKey: null,
  isAuthenticated: false,

  login: (user, tokens, privateKey) =>
    set({
      user,
      accessToken: tokens.accessToken,
      privateKey,
      isAuthenticated: true,
    }),

  logout: () => {
    localStorage.removeItem("encryptedPrivateKey");
    localStorage.removeItem("privateKeyIv");
    localStorage.removeItem("privateKeySalt");
    set({
      user: null,
      accessToken: null,
      privateKey: null,
      isAuthenticated: false,
    });
  },

  setAccessToken: (token) =>
    set({ accessToken: token }),
}));
